import { render, staticRenderFns } from "./NavigationDrawerManutencaoImpeditivo.vue?vue&type=template&id=6cfea0ba&scoped=true&"
import script from "./NavigationDrawerManutencaoImpeditivo.vue?vue&type=script&lang=ts&"
export * from "./NavigationDrawerManutencaoImpeditivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfea0ba",
  null
  
)

export default component.exports